import * as S from './style';
import * as C from '../style';
import PlusIcon from '@svgIcons/plus.svg';
import TrashIcon from '@svgIcons/trash.svg';
import ScheduleItem from './ScheduleItem';
import { checkIsValidSchedule } from './utils';

const MAX_SCHEDULES = 3;
const canAddSchedule = (schedules) => schedules?.length < MAX_SCHEDULES;

const isDuplicateSchedule = (schedule, index, schedules) => {
    if (!checkIsValidSchedule(schedule)) {
        return false;
    }

    const firstIndex = schedules.findIndex(
        (s) =>
            checkIsValidSchedule(s) &&
            s.hour === schedule.hour &&
            s.minute === schedule.minute
    );

    return firstIndex !== -1 && firstIndex < index;
};

export const SchedulesSettings = {
    name: 'SchedulesSettings',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        setValue(value) {
            this.$emit('change', value);
        },
        handleAddSchedule() {
            this.setValue([...this.value, {}]);
        },
        handleRemoveSchedule(index) {
            this.setValue(this.value.filter((_, i) => i !== index));
        },
    },
    render() {
        const { value: schedules } = this;

        return (
            <C.ConfigWrapper>
                <C.ConfigTitle>
                    {this.$t('EXPORT_DATA.form_label_schedules')}
                </C.ConfigTitle>
                <C.ConfigSubTitle style={{ marginBottom: '12px' }}>
                    {this.$t('EXPORT_DATA.description_schedules')}
                </C.ConfigSubTitle>
                <S.SchedulesContent>
                    {schedules.map((item, index) => {
                        const scheduleItemProps = {
                            props: { value: item },
                            on: {
                                change: (newValue) => {
                                    const newSchedules = R.update(
                                        index,
                                        newValue,
                                        schedules
                                    );
                                    this.setValue(newSchedules);
                                },
                            },
                        };

                        const isDuplicate = isDuplicateSchedule(
                            item,
                            index,
                            schedules
                        );

                        return (
                            <S.ScheduleItemWrapper key={index}>
                                <S.ScheduleItemContainer>
                                    <ScheduleItem {...scheduleItemProps} />
                                    <S.RemoveButton
                                        onClick={() =>
                                            this.handleRemoveSchedule(index)
                                        }
                                    >
                                        <TrashIcon
                                            v-view-box
                                            width="16"
                                            height="16"
                                        />
                                    </S.RemoveButton>
                                </S.ScheduleItemContainer>
                                {isDuplicate && (
                                    <S.ErrorMessage>
                                        {this.$t(
                                            'EXPORT_DATA.duplicate_schedule_error'
                                        )}
                                    </S.ErrorMessage>
                                )}
                            </S.ScheduleItemWrapper>
                        );
                    })}
                    {canAddSchedule(schedules) && (
                        <S.AddScheduleButton onClick={this.handleAddSchedule}>
                            <PlusIcon v-view-box width="24" height="24" />
                            {this.$t('EXPORT_DATA.add_schedule')}
                        </S.AddScheduleButton>
                    )}
                </S.SchedulesContent>
            </C.ConfigWrapper>
        );
    },
};

export default SchedulesSettings;
